import initalSearch from "./search";

export const initialState = () => ({
  search: initalSearch({})
});
